(function () {
  'use strict';
  if (window.__aeHeaderSearchBoot) return;
  window.__aeHeaderSearchBoot = true;

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function init() {
    var toggle = document.querySelector('[data-ae-search-toggle]');
    var panel = document.querySelector('[data-ae-header-search]');
    if (!toggle || !panel) return;

    var input = panel.querySelector('[data-ae-search-input]');
    var results = panel.querySelector('[data-ae-search-results]');
    var closeBtn = panel.querySelector('[data-ae-search-close]');
    var form = panel.querySelector('.ae-header-search__form');
    var symbol = panel.getAttribute('data-currency-symbol') || '£';

    var debounceTimer = null;
    var lastQuery = '';
    var activeFetch = 0;

    function open() {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ae-search-open');
      requestAnimationFrame(function () {
        panel.classList.add('is-open');
        try { input.focus(); } catch (_) {}
      });
    }

    function close() {
      panel.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ae-search-open');
      window.setTimeout(function () {
        if (!panel.classList.contains('is-open')) panel.hidden = true;
      }, 200);
    }

    function isOpen() {
      return !panel.hidden;
    }

    function renderProducts(products, query) {
      if (!products.length) {
        results.innerHTML = '<p class="ae-header-search__empty">No matches for &ldquo;' + escapeHtml(query) + '&rdquo; &mdash; try &ldquo;matcha&rdquo; or &ldquo;shilajit&rdquo;.</p>';
        results.hidden = false;
        return;
      }
      var html = '<ul class="ae-header-search__list" role="list">';
      products.forEach(function (p) {
        var imgUrl = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
        if (imgUrl) imgUrl += (imgUrl.indexOf('?') === -1 ? '?' : '&') + 'width=120';
        var img = imgUrl
          ? '<img class="ae-header-search__item-img" src="' + escapeHtml(imgUrl) + '" alt="" loading="lazy" width="52" height="52">'
          : '<span class="ae-header-search__item-img ae-header-search__item-img--empty"></span>';
        html += ''
          + '<li>'
          +   '<a class="ae-header-search__item" href="' + escapeHtml(p.url) + '">'
          +     img
          +     '<span class="ae-header-search__item-info">'
          +       '<span class="ae-header-search__item-title">' + escapeHtml(p.title) + '</span>'
          +       '<span class="ae-header-search__item-price">' + escapeHtml(symbol + p.price) + '</span>'
          +     '</span>'
          +     '<svg class="ae-header-search__item-arrow" viewBox="0 0 24 24" width="14" height="14" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          +   '</a>'
          + '</li>';
      });
      html += '</ul>';
      results.innerHTML = html;
      results.hidden = false;
    }

    function runSearch(query) {
      var fetchId = ++activeFetch;
      var url = '/search/suggest.json'
        + '?q=' + encodeURIComponent(query)
        + '&resources[type]=product'
        + '&resources[limit]=8'
        + '&resources[options][unavailable_products]=hide';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (fetchId !== activeFetch) return;
          if (input.value.trim() !== query) return;
          var products = (((data || {}).resources || {}).results || {}).products || [];
          products = products.filter(function (p) {
            var h = String(p.handle || '');
            return h.indexOf('upsell-') !== 0 && h.indexOf('cart-upsell-') !== 0;
          });
          renderProducts(products, query);
        })
        .catch(function () {});
    }

    toggle.addEventListener('click', function () {
      if (isOpen()) close();
      else open();
    });

    if (closeBtn) closeBtn.addEventListener('click', close);

    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim();
        window.clearTimeout(debounceTimer);
        if (q.length < 2) {
          results.hidden = true;
          results.innerHTML = '';
          lastQuery = '';
          return;
        }
        if (q === lastQuery) return;
        debounceTimer = window.setTimeout(function () {
          lastQuery = q;
          runSearch(q);
        }, 250);
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        if (input.value.trim().length === 0) e.preventDefault();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
    });

    document.addEventListener('click', function (e) {
      if (!isOpen()) return;
      if (panel.contains(e.target) || toggle.contains(e.target)) return;
      close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
